import { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material'
import Sidebar from './Sidebar'
import Topbar from './Topbar'

const DRAWER_WIDTH = 260

const Layout = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    // On initial load, check localStorage for desktop preference
    if (typeof window !== 'undefined' && !isMobile) {
      const saved = localStorage.getItem('sidebarOpen')
      return saved !== null ? JSON.parse(saved) : true
    }
    return false // Closed by default on mobile
  })

  // Update sidebar state when screen size changes
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false)
    }
  }, [isMobile])

  // Persist desktop sidebar state
  useEffect(() => {
    if (!isMobile) {
      localStorage.setItem('sidebarOpen', JSON.stringify(sidebarOpen))
    }
  }, [sidebarOpen, isMobile])

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const handleSidebarClose = () => {
    setSidebarOpen(false)
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar
        open={sidebarOpen}
        onClose={handleSidebarClose}
        onToggle={handleSidebarToggle}
      />
      <Topbar
        onMenuClick={handleSidebarToggle}
        sidebarOpen={sidebarOpen}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // Prevents the flex item from overflowing when its content
          // (wide tables, charts) is larger than the available space.
          minWidth: 0,
          ml: {
            xs: 0,
            md: sidebarOpen ? `${DRAWER_WIDTH}px` : 0,
          },
          backgroundColor: 'background.default',
          minHeight: '100vh',
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Toolbar />
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            // Contain any stray horizontal overflow at the page level so the
            // whole app never scrolls sideways on small screens. Wide tables
            // keep their own scroll containers (DataTable/TableContainer).
            width: '100%',
            maxWidth: '100%',
            overflowX: 'clip',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}

export default Layout
